import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

interface InfiniteScrollLoaderProps {
    hasMore: boolean;
    loadingMore: boolean;
    observerTarget: React.RefObject<HTMLDivElement>;
    dataLength: number;
    endMessage?: string;
    color?: string;
}

export const InfiniteScrollLoader: React.FC<InfiniteScrollLoaderProps> = ({
    hasMore, loadingMore, observerTarget, dataLength, endMessage = '• All items loaded •', color = '#F2674A',
}) => {
    if (dataLength === 0) return null;

    return (
        <Box ref={observerTarget} display="flex" justifyContent="center" alignItems="center" py={3} minHeight="60px">
            {hasMore ? (
                loadingMore ? (
                    <Box display="flex" alignItems="center" gap={1.5}
                        sx={{ background: '#FFFFFF0D', borderRadius: '20px', px: 3, py: 1.5 }}>
                        <CircularProgress size={16} sx={{ color }} />
                        <Typography fontSize="13px" color="#FFFFFF7A" letterSpacing="0.5px">
                            Loading more...
                        </Typography>
                    </Box>
                ) : null  // observer target is invisible until triggered
            ) : (
                <Box display="flex" alignItems="center" gap={1.5}>
                    <Box sx={{ height: '1px', width: '40px', background: '#FFFFFF1A' }} />
                    <Typography fontSize="12px" color="#FFFFFF3A" letterSpacing="1px" textTransform="uppercase">
                        {endMessage}
                    </Typography>
                    <Box sx={{ height: '1px', width: '40px', background: '#FFFFFF1A' }} />
                </Box>
            )}
        </Box>
    );
};